import {AfterViewInit, Component, NgZone, OnDestroy, ViewChild} from '@angular/core';
import {CardComponent} from "../../components/ui/card/card.component";
import {MapComponent} from "../../components/ui/map/map.component";
import {firstValueFrom, map, Subscription, switchMap} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import {PointCloudService} from "../../services/point-cloud.service";
import {ProjectPhotoService} from "../../services/project-photo.service";
import {
  ProjectPhotoViewModalComponent
} from "../../components/modals/project-photo-view-modal/project-photo-view-modal.component";
import {ModalService} from "../../services/modal.service";
import {MapMouseEvent} from "mapbox-gl";

@Component({
  selector: 'app-project-detail-map',
  standalone: true,
  imports: [
    CardComponent,
    MapComponent
  ],
  templateUrl: './project-detail-map.component.html',
  styleUrl: './project-detail-map.component.scss'
})
export class ProjectDetailMapComponent implements AfterViewInit, OnDestroy {
  @ViewChild('map') map?: MapComponent;
  subscriptions: Subscription[] = [];
  project$ = this.route.parent!.data.pipe(map(data => data['project']));
  pointClouds$ = this.project$
    .pipe(switchMap(project => this.pointCloudService.all(project)));
  projectPhotos$ = this.project$
    .pipe(switchMap(project => this.projectPhotoService.list(project)));

  constructor(private pointCloudService: PointCloudService, private modalService: ModalService, private projectPhotoService: ProjectPhotoService, private ngZone: NgZone, private router: Router, private route: ActivatedRoute) {
  }

  openPointCloud(projectId: number, pointCloudId: number) {
    this.ngZone.run(() => {
      this.router.navigate(['panel', 'projects', projectId, 'point-clouds', 'detail', pointCloudId, 'info']);
    });
  }

  ngAfterViewInit() {
    this.subscriptions.push(
      this.pointClouds$.subscribe(pointClouds => {
        pointClouds
          .filter(pointCloud => pointCloud.locationPoints.length > 0)
          .forEach(pointCloud => {
            if (this.map) {
              const line = pointCloud.locationPoints.map(point => ({ lat: point.latitude, lng: point.longitude }));

              this.map.createPolyline(String(pointCloud.id), line, async (event: MapMouseEvent) => {
                // If the Ctrl/Cmd key is pressed, do not open the point cloud

                if (event.originalEvent.ctrlKey || event.originalEvent.metaKey) {
                  return;
                }

                const project = await firstValueFrom(this.project$);

                this.openPointCloud(project.id, pointCloud.id);
              });
            }
          });
      }),

      this.projectPhotos$.subscribe(projectPhotos => {
        projectPhotos
          .filter(projectPhoto => projectPhoto.latitude && projectPhoto.longitude)
          .forEach(async projectPhoto => {
            if (this.map) {
              const point = { lat: projectPhoto.latitude!, lng: projectPhoto.longitude! };

              // Download thumbnail to show on map
              const thumbnailBlob = await firstValueFrom(this.projectPhotoService.thumbnail(projectPhoto));
              const thumbnailUrl = URL.createObjectURL(thumbnailBlob);

              this.map.createMarker(point, async () => {
                this.modalService.open(ProjectPhotoViewModalComponent, {
                  data: {
                    projectPhoto: projectPhoto,
                  }
                });
              }, thumbnailUrl);
            }
          });
      })
    )
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
